import { Section, eType, SectionInitData } from "../../Section";
import { Settings } from "./Settings";
import { NodeList } from "../../../../../Utils/Collections/NodeList";
import { FREE_OBSTACLES, Car, FREE_BONUSES } from "./Obstacles";
import { Node } from "../../../../../Utils/Collections/Node";
import { TIMER } from "../../../../Gameplay";
import { RND } from "../../../../../Utils/RND";
import { BonusManager } from "../../../../Bonuses/BonusManager";
import { BasicObstacle } from "../../../Obstacle";
import { Pool } from "../../../../../Utils/Collections/Pool";
import { Character } from "../../../../Player/Character";
import { LevelManager } from "../../../../Levels";
import { rnd } from "../../../../../Game";



export abstract class RoadBase extends Section {
    /**
     * Nastaveni pro jednotlive pruhy silnice
     */
    protected _settings: Settings[];

    /**
     * Cas aktivace dalsi prekazky pro jednotlive pruhy silnice
     */
    protected _nextObsActTime: number[];

    /**
     * Seznam aktivnich prekazek
     */
    protected _actObstacles: NodeList<BasicObstacle>;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(name: string, type: eType, laneCnt: number) {
        super(name, type, true);

        // Prekazky
        this._actObstacles = new NodeList<Car>();

        this._nextObsActTime = [];

        for (let i = 0; i < laneCnt; i++)
            this._nextObsActTime.push(0);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    activate(z: number, initData: SectionInitData): Section {
        let reqObsCnt = LevelManager.INSTANCE.lvlSettings.obstacles.maxSimCars;

        FREE_OBSTACLES.forEach((pool: Pool<BasicObstacle>, i: number) => {
            if (pool.allocatedItemCnt < reqObsCnt[i])
                pool.createItems(reqObsCnt[i] - pool.size);
        });

        super.activate(z, initData);
        this._settings = (<RoadInitData>initData).settings;

        return this;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    deactivate(): Section {
        this.clearObstacles();
        return super.deactivate();
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    reset(): void {
        // Uvolnit aktivni prekazky
        this.clearObstacles();

        // Nastavit cas aktivace pristi prekazky
        for (let i = 0; i < this._settings.length; i++)
            this.setNextObsActTime(i);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    update(): void {
        // Zpracovat aktivni prekazky        
        this._actObstacles.forEach((obs: Car, node: Node<Car>) => {
            if (!obs.update()) {
                obs.reset();
                this._actObstacles.removeByNode(node);
            }
        });

        // Aktivace nove prekazky
        this._nextObsActTime.forEach((nextObsTime: number, i: number) => {
            if (nextObsTime > 0 && TIMER.time >= nextObsTime) {
                this.setNextObsActTime(i);

                let laneSize = (this._size / this._nextObsActTime.length);
                let obs: BasicObstacle;

                let bonus = BonusManager.instance.getBonusToThrow(this);

                if (bonus) {
                    obs = FREE_BONUSES[bonus.uid].getItem();
                }
                else {
                    // Vybrat typ prekazky
                    obs = FREE_OBSTACLES[this._settings[i].chooseObstacleType()].getItem();
                    //console.log("obs: " + obs.type.uid + " | " + FREE_OBSTACLES[i].allocatedItemCnt);
                }

                obs.activate(this._root, laneSize * i + laneSize / 2, 0, 0, this._settings[i]);
                this._actObstacles.add(obs);
            }
        });
    }

    //-------------------------------------------------------------------------
    /**
     * 
     * @param plChar Overit kolize s postavou hrace
     */
    //-------------------------------------------------------------------------
    checkPlCollisions(plChar: Character): void {
        // Detekovat kolizi prekazek s hracem
        let charRc = plChar.collisionRect;
        let secY = this.top;

        this._actObstacles.every((obstacle: Car): boolean => {
            if (obstacle.checkCollision) {
                let obsRc = obstacle.colRect;

                if (obsRc.x < charRc.right && obsRc.right > charRc.x) {
                    if (obsRc.y + secY < charRc.bottom && obsRc.bottom + secY > charRc.y) {
                        // Je kolize                        
                        obstacle.handlePlCollision(plChar);
                        return false;
                    }
                }
            }

            return true;
        });
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private clearObstacles(): void {
        this._actObstacles.forEach((obstacle: Car) => { obstacle.reset(); });
        this._actObstacles.clear();
    }

    //-------------------------------------------------------------------------
    /**
     * Nastavit cas aktivace dalsi prekazky
     */
    //-------------------------------------------------------------------------
    private setNextObsActTime(laneId: number): void {
        let settings = this._settings[laneId];

        if (settings.obsMoveDir != 0) {
            this._nextObsActTime[laneId] = TIMER.time + rnd.randomIntIn(settings.obsMinActDelay, settings.obsMaxActDelay);
        }
        else {
            this._nextObsActTime[laneId] = -1;
        }
    }
}



export class RoadInitData extends SectionInitData {
    /**
     * (RO) Nastaveni pro jednotlive pruhy silnice
     */
    get settings(): Settings[] { return this._settings; }
    private _settings: Settings[];

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(sectionType: eType, settings: Settings[]) {
        super(sectionType);
        this._settings = settings;
    }
}